<template>
  <div>
    <v-card class="card-custom-shadow">
      <v-card-text class="fs-12">
        <div class="mb-2">
          <v-row no-gutters>
            <v-col cols="8" class="fs-14px black--text">
              E-bike Pickup at [Nhận xe tại]?
            </v-col>
            <v-col cols="4">
              <div
                v-if="order.id_branch_delivery"
                class="text-right purple--text"
              >
                Available: {{ showQuantity }}
              </div>
            </v-col>
          </v-row>
        </div>
        <v-row dense>
          <v-col cols="12">
            <div class="">
              <v-radio-group
                v-model="order.delivery_type"
                hide-details
                class="c-input-small mt-0 mb-1"
                dense
                @change="onDeliveryTypeChanged"
              >
                <v-row dense>
                  <v-col cols="6">
                    <v-radio label="Emove Shop" :value="2"></v-radio>
                  </v-col>
                  <v-col cols="6">
                    <v-radio
                      label="Delivery (giao tận nơi)"
                      :value="1"
                    ></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
            </div>
          </v-col>
          <template v-if="order.delivery_type == 2">
            <v-col cols="12">
              <v-autocomplete
                v-model="order.id_branch_delivery"
                :items="branchOptions"
                class="c-input-small"
                outlined
                dense
                hide-details
                label="Select [Chọn]"
                placeholder="Select [Chọn]"
                @change="getBikeAvailable"
              ></v-autocomplete>
            </v-col>
          </template>
          <template v-else>
            <v-col cols="6">
              <SelectCity
                name="delivery_id_city"
                class="c-input-small"
                :id-country="1"
                :id-city="order.delivery_id_city"
                :is-check-delivery="true"
                label="Province [Tỉnh/TP]"
                @onChange="onChange"
                ref="selectCityRef"
              />
            </v-col>
            <v-col cols="6">
              <SelectCounty
                name="delivery_id_county"
                class="c-input-small"
                :id-city="order.delivery_id_city"
                :id-county="order.delivery_id_county"
                :is-check-delivery="true"
                label="District [Quận/Huyện]"
                @onChange="onChange"
              />
            </v-col>
            <v-col cols="6">
              <SelectWard
                name="delivery_id_ward"
                class="c-input-small"
                :id-city="order.delivery_id_city"
                :id-county="order.delivery_id_county"
                :id-ward="order.delivery_id_ward"
                :is-check-delivery="true"
                label="Ward [Phường/Xã]"
                @onChange="onChange"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="order.delivery_address"
                class="c-input-small"
                dense
                outlined
                hide-details
                label="Address [Địa chỉ]"
              ></v-text-field>
            </v-col>
          </template>
          <v-col cols="4">
            <date-picker-model
              v-model="startDate"
              label="Day [Ngày]"
              custom-class="c-input-small"
              outlined
              dense
              hide-details
              :single-line="false"
              :min-date="minDate"
            ></date-picker-model>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              v-model="startHour"
              :items="hourOptions"
              class="c-input-small"
              outlined
              dense
              hide-details
              label="Hour [Giờ]"
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              v-model="startMinute"
              :items="minOptions"
              class="c-input-small"
              outlined
              dense
              hide-details
              label="Min [Phút]"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <div class="mt-3 font-italic error--text fs-10 lh-12">
          <template v-if="order.delivery_type == 2">
            <div class="mb-1">Working time: 8am - 9pm</div>
            <div>Thời gian làm việc: 8-21h</div>
          </template>
          <template v-else>
            <div class="mb-1">
              *The delivery and return at your address are available from 8:30
              AM to 8:00 PM daily, with the fee calculated based on distance.
            </div>
            <div>
              *Dịch vụ giao và trả xe tại tận nơi được thực hiện từ 8:30 sáng
              đến 8:00 tối hàng ngày, mức phí tính theo khoảng cách thực tế.
            </div>
          </template>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { ORDER_CREATE_DEFAULT_BOOKING_DELIVERY } from "@/libs/const";
import { httpClient } from "@/libs/http";
import moment from "moment/moment";

export default {
  name: "BookingDelivery",
  components: {
    SelectCity: () => import("@/components/common/SelectCity"),
    SelectCounty: () => import("@/components/common/SelectCounty"),
    SelectWard: () => import("@/components/common/SelectWard"),
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    summary: {
      type: Object,
      default: () => {},
    },
    vouchers: {
      type: Array,
      default: () => [],
    },
    branches: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    isLoading: false,
    order: { ...ORDER_CREATE_DEFAULT_BOOKING_DELIVERY },
    bikeAvailable: 0,
    startDate: null,
    startHour: null,
    startMinute: null,
  }),
  computed: {
    minDate() {
      return moment().format("YYYY-MM-DD");
    },
    startTime() {
      console.log(this.startDate, this.startHour, this.startMinute);
      if (!this.startDate || !this.startHour || !this.startMinute) {
        return null;
      }
      return `${this.startDate} ${this.startHour}:${this.startMinute}:00`;
    },
    hourOptions() {
      const today = moment().format("YYYY-MM-DD");
      const nowHour = moment().hour();
      let h = 0;
      if (this.startDate == today) {
        h = nowHour;
      }
      const hours = [];
      for (let i = 6; i < 23; i++) {
        if (i >= h) {
          hours.push(i < 10 ? `0${i}` : `${i}`);
        }
      }
      return hours;
    },
    minOptions() {
      const today = moment().format("YYYY-MM-DD");
      const nowHour = moment().hour();
      const nowMin = moment().minute();
      let m = 0;
      if (this.startDate == today && +this.startHour == nowHour) {
        m = nowMin;
      }
      const minutes = [];
      for (let i = 0; i < 60; i += 15) {
        if (i >= m) {
          minutes.push(i < 10 ? `0${i}` : `${i}`);
        }
      }
      return minutes;
    },
    branchOptions() {
      return [...this.branches].map((d) => ({
        text: d.code,
        value: d.id,
      }));
    },
    showQuantity() {
      if (!this.order.id_branch_delivery) {
        return 0;
      }
      const branch = [...this.branches].find(
        (b) => b.id == this.order.id_branch_delivery
      );

      if (!branch) {
        return 0;
      }

      const quantity = this.bikeAvailable - branch.min_bike;
      return quantity > 0 ? quantity : 0;
    },
  },
  watch: {
    order: {
      handler() {
        this.$emit("onUpdate", this.order);
      },
      deep: true,
    },
    startTime() {
      this.setStartTime();
    },
  },
  created() {
    if (this.info && this.info.id) {
      if (this.info.start_time) {
        this.startDate = moment(this.info.start_time).format("YYYY-MM-DD");
        this.startHour = moment(this.info.start_time).format("HH");
        this.startMinute = moment(this.info.start_time).format("mm");
      }
      this.order = {
        ...this.order,
        delivery_type: this.info.id_branch_delivery ? 2 : 1,
        id_branch_delivery: this.info.id_branch_delivery,
        delivery_id_city: this.info.delivery_id_city,
        delivery_id_county: this.info.delivery_id_county,
        delivery_id_ward: this.info.delivery_id_ward,
        delivery_address: this.info.delivery_address,
        start_time: this.info.start_time
          ? moment(this.info.start_time).format("YYYY-MM-DD HH:mm:ss")
          : null,
      };
      this.getBikeAvailable();
    }
  },
  methods: {
    setStartTime() {
      this.order = { ...this.order, start_time: this.startTime };
      console.log(JSON.stringify(this.order));
    },
    onDeliveryTypeChanged() {
      this.startDate = null;
      this.startHour = null;
      this.startMinute = null;
      this.order = {
        ...this.order,
        delivery_id_city: null,
        delivery_id_county: null,
        delivery_id_ward: null,
        delivery_address: null,
        id_branch_delivery: null,
        start_time: null,
      };
    },
    onChange(item) {
      this.order = { ...this.order, [item.name]: item.value };
    },
    onReset() {
      this.order = { ...ORDER_CREATE_DEFAULT_BOOKING_DELIVERY };
    },
    async getBikeAvailable() {
      const branch = [...this.branches].find(
        (br) => br.id == this.order.id_branch_delivery
      );
      if (branch) {
        this.order = { ...this.order, delivery_id_city: branch.id_city };
      }
      const { data } = await httpClient.post(
        "/asset/v1/get-bike-available-by-branch",
        {
          id_branch: this.order.id_branch_delivery,
        }
      );
      this.bikeAvailable = data;
    },
  },
};
</script>
